import { useCallback, useMemo, useState } from 'react';
import { Props as ModalProps } from 'components/Modal';

export type Opts = {
  initialOpen?: boolean;
  dismissable?: boolean;
};

type UseModalValue = {
  modalProps: ModalProps;
  openModal: () => void;
  closeModal: () => void;
};

export const useModal = ({ initialOpen = false, dismissable = true }: Opts = {}): UseModalValue => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const modalProps = useMemo(
    () => ({
      open: isOpen,
      dismissable,
      onRequestClose: closeModal,
    }),
    [dismissable, closeModal, isOpen],
  );

  return {
    modalProps,
    openModal,
    closeModal,
  };
};
